/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import HeaderSection from "../../components/HeaderSection";
import { addUser } from "../../http";
import Modal from "../../components/modal/Modal";



const AddUser = () => {
  const [imagePreview, setImagePreview] = useState("/assets/icons/user.png");
  // Enhanced initial state with additional fields
  const initialState = {
    // Required fields
    name: "",
    email: "",
    mobile: "",
    password: "",
    type: "Employee",
    currentLocation: "",
    permanentAddress: { address: "", pincode: "" },
    presentAddress: { address: "", pincode: "" },
    profile: "",
    adminPassword: "",

    // Professional Details (Required)
    totalExperience: "",
    relevantExperience:"",
    currentCTC: "",
    expectedCTC: "",
    noticePeriod: "",
    willingToWorkShifts: "Yes",

    // Education - array of education records (Required)
    education: [
      {
        exam: "",
        stream: "",
        percentage: "",
        passingYear: "",
        institution: "",
      },
    ],
    trainingAndCertification: [
      {
        name: "",
        organization: "",
        period: { startDate: "", endDate: "" },
      },
    ],
    acquaintance: [
      {
        name: "",
        relationship: "",
        department: "",
        organization: "",
        
      },
    ],

    // Work experience - array of work records (Required)
    workExperience: [
      {
        employer: "",
        designation: "",
        doj: "",
        dol: "",
        tenure: "",
        salary: "",
        reasonForLeaving: "",
      },
    ],

    // References (Required)
    references: [
      {
        name: "",
        position: "",
        organization: "",
        mobile: "",
      },
      {
        name: "",
        position: "",
        organization: "",
        mobile: "",
      },
    ],

    // Optional fields
    dob: "",
    dom:"",
    age: "",
    maritalStatus: "Single",
    birthPlace: "",
    // Family details
    father: { name: "", occupation: "", contact: "" },
    mother: { name: "", occupation: "", contact: "" },
    spouse: { name: "", occupation: "", contact: "" },
    siblings: [{ name: "", occupation: "", contact: "" }],
    children: [{ name: "", occupation: "", contact: "" }]
  };

  const [formData, setFormData] = useState(initialState);
  const [showModal, setShowModal] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [sameAsPresent, setSameAsPresent] = useState(false);

  // Calculate age when DOB changes
  useEffect(() => {
    if (formData.dob) {
      const birthDate = new Date(formData.dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setFormData((prev) => ({ ...prev, age: age.toString() }));
    }
  }, [formData.dob]);

  const inputEvent = (e) => {
    const { name, value } = e.target;
    // Handle address and pincode fields for present and permanent addresses
    if (name === "presentAddress") {
      setFormData((old) => ({
        ...old,
        presentAddress: { ...old.presentAddress, address: value },
      }));
    } else if (name === "presentPincode") {
      setFormData((old) => ({
        ...old,
        presentAddress: { ...old.presentAddress, pincode: value },
      }));
    } else if (name === "permanentAddress") {
      setFormData((old) => ({
        ...old,
        permanentAddress: { ...old.permanentAddress, address: value },
      }));
    } else if (name === "permanentPincode") {
      setFormData((old) => ({
        ...old,
        permanentAddress: { ...old.permanentAddress, pincode: value },
      }));
    } else {
      setFormData((old) => ({
        ...old,
        [name]: value,
      }));
    }
  };
  //handle permanent address same as present address
  const handleSameAsPresent = (e) => {
    const isChecked = e.target.checked;
    setSameAsPresent(isChecked);
    
    if (isChecked) {
      setFormData((prev) => ({
        ...prev,
        permanentAddress: { ...prev.presentAddress },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        permanentAddress: { address: "", pincode: "" },
      }));
    }
  };

  // Handle nested object updates (family details)
  const handleFamilyInput = (e, member) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [member]: {
        ...prev[member],
        [name]: value,
      },
    }));
  };

  // Handle array item updates (siblings, education, work experience)
  const handleArrayInput = (e, arrayName, index) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const newArray = [...prev[arrayName]];
      newArray[index] = { ...newArray[index], [name]: value };
      return {
        ...prev,
        [arrayName]: newArray,
      };
    });
  };

  // Add new item to an array (siblings, education, work experience,traning/certificatoins)
  const addArrayItem = (arrayName, template) => {
    setFormData((prev) => ({
      ...prev,
      [arrayName]: [...prev[arrayName], template],
    }));
  };

  // Remove item from array
  const removeArrayItem = (arrayName, index) => {
    setFormData((prev) => ({
      ...prev,
      [arrayName]: prev[arrayName].filter((_, i) => i !== index),
    }));
  };

  // Calculate tenure when DOJ or DOL changes
  const calculateTenure = (index) => {
    const exp = formData.workExperience[index];
    if (exp.doj && exp.dol) {
      const startDate = new Date(exp.doj);
      const endDate = new Date(exp.dol);

      // Calculate difference in months
      const months =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth());

      const years = Math.floor(months / 12);
      const remainingMonths = months % 12;

      const tenure = `${years} year${
        years !== 1 ? "s" : ""
      } ${remainingMonths} month${remainingMonths !== 1 ? "s" : ""}`;

      // Update the tenure field
      const updatedWorkExperience = [...formData.workExperience];
      updatedWorkExperience[index] = {
        ...updatedWorkExperience[index],
        tenure,
      };

      setFormData((prev) => ({
        ...prev,
        workExperience: updatedWorkExperience,
      }));
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const {
      name,
      email,
      mobile,
      password,
      type,
      currentLocation,
      permanentAddress,
      presentAddress,
      profile,
      education,
      trainingAndCertification,
      acquaintance,
      workExperience
    } = formData;

    // Validate basic required fields
    if (!name || !email || !mobile || !password || !type || !currentLocation || !formData.permanentAddress.address || !formData.permanentAddress.pincode || !formData.presentAddress.address || !formData.presentAddress.pincode) {
      return toast.error(
        "Please fill in all required basic information fields (Name, Email, Mobile, Password, Type, Address)"
      );
    }
    if (!profile) return toast.error("Please choose a profile image");

    // Validate education
    if (
      !education.length ||
      education.some(
        (edu) =>
          !edu.exam ||
          !edu.stream ||
          !edu.percentage ||
          !edu.passingYear ||
          !edu.institution
      )
    ) {
      return toast.error("Please fill in all education details completely");
    }
    if (
      !trainingAndCertification.length ||
      trainingAndCertification.some(
        (train) =>
          !train.name ||
          !train.organization ||
          !train.period.startDate ||
          !train.period.endDate
      )
    ) {
      return toast.error("Please fill in all Training and Certification details completely");
    }
    if (
      !acquaintance.length ||
      acquaintance.some(
        (acq) =>
          !acq.name ||
          !acq.relationship ||
          !acq.department ||
          !acq.organization
      )
    ) {
      return toast.error("Please fill in all Acquaintance details completely");
    }

    // Validate work experience
    if (
      !workExperience.length ||
      workExperience.some(
        (exp) =>
          !exp.employer ||
          !exp.designation ||
          !exp.doj ||
          !exp.dol ||
          !exp.salary
      )
    ) {
      return toast.error(
        "Please fill in all work experience details completely"
      );
    }

    if (type === "Admin" && !showModal) {
      setShowModal(true);
      return;
    }

    const fd = new FormData();

    // Add simple key-value pairs
    for (const key in formData) {
      if (key === "permanentAddress" || key === "presentAddress") {
        fd.append(key, JSON.stringify(formData[key]));
      } else if (typeof formData[key] !== "object") {
        fd.append(key, formData[key]);
      }
    }

    // Properly stringify nested objects
    const familyData = {
      father: formData.father,
      mother: formData.mother,
      spouse: formData.spouse,
      siblings: formData.siblings || [],
      children: formData.children || [],
    };

    // Make sure to stringify the entire objects
    fd.append("family", JSON.stringify(familyData));
    fd.append("education", JSON.stringify(formData.education || []));
    fd.append("trainingAndCertification", JSON.stringify(formData.trainingAndCertification || []));
    fd.append("acquaintance", JSON.stringify(formData.acquaintance|| []));
    fd.append("workExperience", JSON.stringify(formData.workExperience || []));

    console.log("Form Data being sent:", Object.fromEntries(fd.entries()));
    const { success, message } = await addUser(fd);
    if (success) {
      toast.success(message);
      setShowModal(false);
      setFormData({ ...initialState });
      setImagePreview("/assets/icons/user.png");
      setShowAdvanced(false);
    }
  };

  const captureImage = (e) => {
    const file = e.target.files[0];
    setFormData((old) => {
      return {
        ...old,
        profile: file,
      };
    });
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
  };

  const modalAction = () => setShowModal(showModal ? false : true);

  return (
    <>
      {showModal && (
        <Modal close={modalAction} title="Add Admin" width="35%">
          <div className="row" style={{ margin: "20px" }}>
            <div className="col col-md-4">
              <div className="input-group justify-content-center text-center">
                <img
                  className="rounded"
                  src={imagePreview}
                  width="120"
                  alt=""
                />
              </div>
            </div>
            <div className="col col-md-8">
              <table className="table table-md">
                <tbody>
                  <tr>
                    <th>Name</th>
                    <td>{formData.name}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{formData.email}</td>
                  </tr>
                  <tr>
                    <th>User Type</th>
                    <td>{formData.type}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="form-group col-md-12">
            <label>Enter Your Password</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <i className="fas fa-lock"></i>
                </div>
              </div>
              <input
                onChange={inputEvent}
                value={formData.adminPassword}
                type="password"
                placeholder={`Enter Your Password To Add ${formData.name} As An Admin`}
                id="adminPassword"
                name="adminPassword"
                className="form-control"
              />
            </div>
          </div>
          <div className="justify-content-center text-center mb-3">
            <button
              className="btn btn-primary btn-lg"
              type="submit"
              form="addUserForm"
              style={{ width: "30vh" }}>
              Add {formData.type}
            </button>
          </div>
        </Modal>
      )}

      <div className="main-content">
        <section className="section">
          <HeaderSection title="Add User" />
          <div className="card">
            <div className="card-body pr-5 pl-5 m-1">
              <form className="row" onSubmit={onSubmit} id="addUserForm">
                <div className="form-group col-md-12 text-center">
                  <div className="input-group justify-content-center">
                    <input
                      type="file"
                      id="profile"
                      name="profile"
                      className="form-control d-none"
                      onChange={captureImage}
                      accept="image/*"
                    />
                    <label htmlFor="profile">
                      {" "}
                      <img
                        className="rounded"
                        src={imagePreview}
                        width="120"
                        alt=""
                      />{" "}
                    </label>
                  </div>
                </div>

                {/* Required Fields Section */}
                <div className="col-md-12">
                  <h4 className="text-primary">Required Information</h4>
                  <hr />
                </div>

                <div className="form-group col-md-6">
                  <label>
                    Enter Name <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-user"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.name}
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                <div className="form-group col-md-6">
                  <label>
                    Enter Email <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-envelope"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.email}
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                <div className="form-group col-md-4">
                  <label>
                    Enter Mobile Number <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-phone"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.mobile}
                      type="number"
                      id="mobile"
                      name="mobile"
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                <div className="form-group col-md-4">
                  <label>
                    Enter Password <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-lock"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.password}
                      type="password"
                      id="password"
                      name="password"
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                <div className="form-group col-md-4">
                  <label>
                    User Type <span className="text-danger">*</span>
                  </label>
                  <select
                    name="type"
                    onChange={inputEvent}
                    value={formData.type}
                    className="form-control select2"
                    required>
                    <option>Employee</option>
                    <option>Leader</option>
                    <option>Admin</option>
                    <option>Intern</option>
                  </select>
                </div>

                <div className="form-group col-md-12">
                  <label>
                    Current Location <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.currentLocation}
                      type="text"
                      id="currentLocation"
                      name="currentLocation"
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="form-group col-md-8">
                  <label>
                    Present Address <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.presentAddress.address}
                      type="text"
                      id="presentAddress"
                      name="presentAddress"
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                <div className="form-group col-md-4">
                  <label>
                    Pincode <span className="text-danger">*</span>
                  </label>
                  <input
                    onChange={inputEvent}
                    value={formData.presentAddress.pincode}
                    type="number"
                    id="presentPincode"
                    name="presentPincode"
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group col-md-12">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="sameAsPresent"
                      checked={sameAsPresent}
                      onChange={handleSameAsPresent}
                    />
                    <label className="form-check-label" htmlFor="sameAsPresent">
                      <strong>Permanent address is same as present address</strong>
                    </label>
                  </div>
                </div>

                <div className="form-group col-md-8">
                    <label>
                      Permanent Address <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <div className="input-group-text">
                          <i className="fas fa-map-marker-alt"></i>
                        </div>
                      </div>
                      <input
                        onChange={inputEvent}
                        value={formData.permanentAddress.address}
                        type="text"
                        id="permanentAddress"
                        name="permanentAddress"
                        className="form-control"
                        disabled={sameAsPresent}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group col-md-4">
                    <label>
                      Pincode <span className="text-danger">*</span>
                    </label>
                    <input
                      onChange={inputEvent}
                      value={formData.permanentAddress.pincode}
                      type="number"
                      id="permanentPincode"
                      name="permanentPincode"
                      className="form-control"
                      disabled={sameAsPresent}
                      required
                    />
                  </div>

                {/* Toggle for Advanced/Optional Fields */}
                <div className="form-group col-md-12">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowAdvanced(!showAdvanced)}>
                    {showAdvanced ? "Hide" : "Show"} Additional Details
                  </button>
                </div>

                {showAdvanced && (
                  <>
                    {/* Personal Details Section */}
                    <div className="col-md-12">
                      <h4 className="text-primary">Personal Details</h4>
                      <hr />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Date of Birth</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text">
                            <i className="fas fa-calendar"></i>
                          </div>
                        </div>
                        <input
                          onChange={inputEvent}
                          value={formData.dob}
                          type="date"
                          id="dob"
                          name="dob"
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      <label>Age</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text">
                            <i className="fas fa-user-clock"></i>
                          </div>
                        </div>
                        <input
                          value={formData.age}
                          type="text"
                          id="age"
                          name="age"
                          className="form-control"
                          disabled
                          placeholder="Auto-calculated from DOB"
                        />
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      <label>Marital Status</label>
                      <select
                        name="maritalStatus"
                        onChange={inputEvent}
                        value={formData.maritalStatus}
                        className="form-control select2">
                        <option>Single</option>
                        <option>Married</option>
                        <option>Divorced</option>
                        <option>Widowed</option>
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Date of Marriage</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text">
                            <i className="fas fa-calendar"></i>
                          </div>
                        </div>
                        <input
                          onChange={inputEvent}
                          value={formData.dom}
                          type="date"
                          id="dom"
                          name="dom"
                          className="form-control"
                          disabled={!["Married", "Divorced", "Widowed"].includes(formData.maritalStatus)}
                        />
                      </div>
                    </div>

                    <div className="form-group col-md-12">
                  <label>
                    Birth Place<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.birthPlace}
                      type="text"
                      id="birthPlace"
                      name="birthPlace"
                      className="form-control"
                      
                    />
                  </div>
                  </div>

                    {/* Family Background Section */}
                    <div className="col-md-12">
                      <h4 className="text-primary">Family Background</h4>
                      <hr />
                    </div>

                    <div className="form-group col-md-4">
                      <label>Father's Name</label>
                      <input
                        onChange={(e) => handleFamilyInput(e, "father")}
                        value={formData.father.name}
                        type="text"
                        name="name"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-md-4">
                      <label>Father's Occupation</label>
                      <input
                        onChange={(e) => handleFamilyInput(e, "father")}
                        value={formData.father.occupation}
                        type="text"
                        name="occupation"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-md-4">
                      <label>Father's Contact</label>
                      <input
                        onChange={(e) => handleFamilyInput(e, "father")}
                        value={formData.father.contact}
                        type="text"
                        name="contact"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-md-4">
                      <label>Mother's Name</label>
                      <input
                        onChange={(e) => handleFamilyInput(e, "mother")}
                        value={formData.mother.name}
                        type="text"
                        name="name"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-md-4">
                      <label>Mother's Occupation</label>
                      <input
                        onChange={(e) => handleFamilyInput(e, "mother")}
                        value={formData.mother.occupation}
                        type="text"
                        name="occupation"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-md-4">
                      <label>Mother's Contact</label>
                      <input
                        onChange={(e) => handleFamilyInput(e, "mother")}
                        value={formData.mother.contact}
                        type="text"
                        name="contact"
                        className="form-control"
                      />
                    </div>

                    {formData.maritalStatus === "Married" && (
                      <>
                        <div className="form-group col-md-4">
                          <label>Spouse's Name</label>
                          <input
                            onChange={(e) => handleFamilyInput(e, "spouse")}
                            value={formData.spouse.name}
                            type="text"
                            name="name"
                            className="form-control"
                          />
                        </div>

                        <div className="form-group col-md-4">
                          <label>Spouse's Occupation</label>
                          <input
                            onChange={(e) => handleFamilyInput(e, "spouse")}
                            value={formData.spouse.occupation}
                            type="text"
                            name="occupation"
                            className="form-control"
                          />
                        </div>

                        <div className="form-group col-md-4">
                          <label>Spouse's Contact</label>
                          <input
                            onChange={(e) => handleFamilyInput(e, "spouse")}
                            value={formData.spouse.contact}
                            type="text"
                            name="contact"
                            className="form-control"
                          />
                        </div>
                      </>
                    )}

                    {formData.maritalStatus === "Married" && (
                      <>
                        <div className="col-md-12">
                          <div className="d-flex justify-content-between align-items-center">
                            <h5 className="text-primary">Children</h5>
                            <button
                              type="button"
                              className="btn btn-sm btn-primary"
                              onClick={() =>
                                addArrayItem("children", {
                                  name: "",
                                  occupation: "",
                                  contact: "",
                                })
                              }
                            >
                              Add Child
                            </button>
                          </div>
                          <hr />
                        </div>

                        {formData.children.map((child, index) => (
                          <div className="col-md-12 mb-3" key={`child-${index}`}>
                            <div className="card">
                              <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h6>Child {index + 1}</h6>
                                  {index > 0 && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-danger"
                                      onClick={() => removeArrayItem("children", index)}
                                    >
                                      Remove
                                    </button>
                                  )}
                                </div>
                                <div className="row">
                                  <div className="form-group col-md-4">
                                    <label>Name</label>
                                    <input
                                      onChange={(e) => handleArrayInput(e, "children", index)}
                                      value={child.name}
                                      type="text"
                                      name="name"
                                      className="form-control"
                                    />
                                  </div>
                                  <div className="form-group col-md-4">
                                    <label>Occupation</label>
                                    <input
                                      onChange={(e) => handleArrayInput(e, "children", index)}
                                      value={child.occupation}
                                      type="text"
                                      name="occupation"
                                      className="form-control"
                                    />
                                  </div>
                                  <div className="form-group col-md-4">
                                    <label>Contact</label>
                                    <input
                                      onChange={(e) => handleArrayInput(e, "children", index)}
                                      value={child.contact}
                                      type="text"
                                      name="contact"
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                    {/* Sibling Section */}
                    <div className="col-md-12">
                      <div className="d-flex justify-content-between align-items-center">
                        <h5 className="text-primary">Siblings</h5>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            addArrayItem("siblings", {
                              name: "",
                              occupation: "",
                              contact: "",
                            })
                          }>
                          Add Sibling
                        </button>
                      </div>
                      <hr />
                    </div>

                    {formData.siblings.map((sibling, index) => (
                      <div className="col-md-12 mb-3" key={`sibling-${index}`}>
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6>Sibling {index + 1}</h6>
                              {index > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() =>
                                    removeArrayItem("siblings", index)
                                  }>
                                  Remove
                                </button>
                              )}
                            </div>
                            <div className="row">
                              <div className="form-group col-md-4">
                                <label>Name</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "siblings", index)
                                  }
                                  value={sibling.name}
                                  type="text"
                                  name="name"
                                  className="form-control"
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Occupation</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "siblings", index)
                                  }
                                  value={sibling.occupation}
                                  type="text"
                                  name="occupation"
                                  className="form-control"
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Contact</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "siblings", index)
                                  }
                                  value={sibling.contact}
                                  type="text"
                                  name="contact"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* Professional Details Section */}
                    <div className="col-md-12">
                      <h4 className="text-primary">Professional Details</h4>
                      <hr />
                    </div>

                    <div className="form-group col-md-3">
                      <label>Total Experience (Years)</label>
                      <input
                        onChange={inputEvent}
                        value={formData.totalExperience}
                        type="number"
                        name="totalExperience"
                        className="form-control"
                        min="0"
                        step="0.1"
                      />
                    </div>
                    <div className="form-group col-md-3">
                      <label>Relevant Experience (Years)</label>
                      <input
                        onChange={inputEvent}
                        value={formData.relevantExperience}
                        type="number"
                        name="relevantExperience"
                        className="form-control"
                        min="0"
                        step="0.1"
                      />
                    </div>

                    <div className="form-group col-md-3">
                      <label>Current CTC (Annual)</label>
                      <input
                        onChange={inputEvent}
                        value={formData.currentCTC}
                        type="number"
                        name="currentCTC"
                        className="form-control"
                        placeholder="In INR"
                      />
                    </div>

                    <div className="form-group col-md-3">
                      <label>Expected CTC (Annual)</label>
                      <input
                        onChange={inputEvent}
                        value={formData.expectedCTC}
                        type="number"
                        name="expectedCTC"
                        className="form-control"
                        placeholder="In INR"
                      />
                    </div>

                    <div className="form-group col-md-3">
                      <label>Notice Period (Days)</label>
                      <input
                        onChange={inputEvent}
                        value={formData.noticePeriod}
                        type="number"
                        name="noticePeriod"
                        className="form-control"
                      />
                    </div>

                    <div className="form-group col-md-3">
                      <label>Willing to Work in Shifts?</label>
                      <select
                        name="willingToWorkShifts"
                        onChange={inputEvent}
                        value={formData.willingToWorkShifts}
                        className="form-control">
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="Maybe">Occasionally if Required</option>
                      </select>
                    </div>

                    {/* Education Section */}
                    <div className="col-md-12">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4 className="text-primary">
                          Educational Qualifications
                        </h4>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            addArrayItem("education", {
                              exam: "",
                              stream: "",
                              percentage: "",
                              passingYear: "",
                              institution: "",
                            })
                          }>
                          Add Education
                        </button>
                      </div>
                      <hr />
                    </div>

                    {formData.education.map((edu, index) => (
                      <div className="col-md-12 mb-3" key={`edu-${index}`}>
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6>Education {index + 1}</h6>
                              {index > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() =>
                                    removeArrayItem("education", index)
                                  }>
                                  Remove
                                </button>
                              )}
                            </div>
                            <div className="row">
                              <div className="form-group col-md-4">
                                <label>Examination/Degree</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "education", index)
                                  }
                                  value={edu.exam}
                                  type="text"
                                  name="exam"
                                  className="form-control"
                                  placeholder="e.g., High School, Bachelor's, Master's"
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Stream/Specialization</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "education", index)
                                  }
                                  value={edu.stream}
                                  type="text"
                                  name="stream"
                                  className="form-control"
                                  placeholder="e.g., Science, Computer Science, Finance"
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Percentage/CGPA</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "education", index)
                                  }
                                  value={edu.percentage}
                                  type="text"
                                  name="percentage"
                                  className="form-control"
                                  placeholder="e.g., 85%, 3.8"
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Year of Passing</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "education", index)
                                  }
                                  value={edu.passingYear}
                                  type="text"
                                  name="passingYear"
                                  className="form-control"
                                  placeholder="e.g., 2018"
                                />
                              </div>
                              <div className="form-group col-md-8">
                                <label>College/University/Institution</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "education", index)
                                  }
                                  value={edu.institution}
                                  type="text"
                                  name="institution"
                                  className="form-control"
                                  placeholder="e.g., Harvard University"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                    {/* Training Section */}
                    <div className="col-md-12">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4 className="text-primary">
                          Training and Certifications
                        </h4>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            addArrayItem("trainingAndCertification", {
                              name: "",
                              organization: "",
                              period: { startDate: "", endDate: "" },
                            })
                          }>
                          Add Training
                        </button>
                      </div>
                      <hr />
                    </div>

                    {formData.trainingAndCertification.map((train, index) => (
                      <div className="col-md-12 mb-3" key={`train-${index}`}>
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6>Training and Certification {index + 1}</h6>
                              {index > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() =>
                                    removeArrayItem("trainingAndCertification", index)
                                  }>
                                  Remove
                                </button>
                              )}
                            </div>
                            <div className="row">
                              
                              <div className="form-group col-md-4">
                                <label>Training/Course Name</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "trainingAndCertification", index)
                                  }
                                  value={train.name}
                                  type="text"
                                  name="name"
                                  className="form-control"
                                  placeholder="AI/ML, Data Science, etc."
                                />
                              </div>
                              
                              <div className="form-group col-md-8">
                                <label>Organization</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "trainingAndCertification", index)
                                  }
                                  value={train.organization}
                                  type="text"
                                  name="organization"
                                  className="form-control"
                                  placeholder="e.g., Harvard University"
                                />
                              </div>
                              <div className="form-group col-md-6">
                                <label>Start Date</label>
                                <input
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setFormData((prev) => {
                                      const arr = [...prev.trainingAndCertification];
                                      arr[index] = {
                                        ...arr[index],
                                        period: {
                                          ...arr[index].period,
                                          startDate: value,
                                        },
                                      };
                                      return { ...prev, trainingAndCertification: arr };
                                    });
                                  }}
                                  value={train.period.startDate}
                                  type="date"
                                  name="startDate"
                                  className="form-control"
                                />
                              </div>
                              <div className="form-group col-md-6">
                                <label>End Date</label>
                                <input
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setFormData((prev) => {
                                      const arr = [...prev.trainingAndCertification];
                                      arr[index] = {
                                        ...arr[index],
                                        period: {
                                          ...arr[index].period,
                                          endDate: value,
                                        },
                                      };
                                      return { ...prev, trainingAndCertification: arr };
                                    });
                                  }}
                                  value={train.period.endDate}
                                  type="date"
                                  name="endDate"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* Work Experience Section */}
                    <div className="col-md-12">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4 className="text-primary">Work Experience</h4>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            addArrayItem("workExperience", {
                              employer: "",
                              designation: "",
                              doj: "",
                              dol: "",
                              tenure: "",
                              salary: "",
                              reasonForLeaving: "",
                            })
                          }>
                          Add Experience
                        </button>
                      </div>
                      <hr />
                    </div>

                    {formData.workExperience.map((exp, index) => (
                      <div className="col-md-12 mb-3" key={`exp-${index}`}>
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6>Experience {index + 1}</h6>
                              {index > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() =>
                                    removeArrayItem("workExperience", index)
                                  }>
                                  Remove
                                </button>
                              )}
                            </div>
                            <div className="row">
                              <div className="form-group col-md-6">
                                <label>Employer/Company Name</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "workExperience", index)
                                  }
                                  value={exp.employer}
                                  type="text"
                                  name="employer"
                                  className="form-control"
                                  placeholder="e.g., Google Inc."
                                />
                              </div>
                              <div className="form-group col-md-6">
                                <label>Designation/Role</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "workExperience", index)
                                  }
                                  value={exp.designation}
                                  type="text"
                                  name="designation"
                                  className="form-control"
                                  placeholder="e.g., Software Engineer"
                                />
                              </div>
                              <div className="form-group col-md-3">
                                <label>Date of Joining</label>
                                <input
                                  onChange={(e) => {
                                    handleArrayInput(
                                      e,
                                      "workExperience",
                                      index
                                    );
                                    setTimeout(
                                      () => calculateTenure(index),
                                      100
                                    );
                                  }}
                                  value={exp.doj}
                                  type="date"
                                  name="doj"
                                  className="form-control"
                                />
                              </div>
                              <div className="form-group col-md-3">
                                <label>Date of Leaving</label>
                                <input
                                  onChange={(e) => {
                                    handleArrayInput(
                                      e,
                                      "workExperience",
                                      index
                                    );
                                    setTimeout(
                                      () => calculateTenure(index),
                                      100
                                    );
                                  }}
                                  value={exp.dol}
                                  type="date"
                                  name="dol"
                                  className="form-control"
                                />
                              </div>
                              <div className="form-group col-md-3">
                                <label>Tenure</label>
                                <input
                                  value={exp.tenure}
                                  type="text"
                                  name="tenure"
                                  className="form-control"
                                  disabled
                                  placeholder="Auto-calculated"
                                />
                              </div>
                              <div className="form-group col-md-3">
                                <label>Salary</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "workExperience", index)
                                  }
                                  value={exp.salary}
                                  type="text"
                                  name="salary"
                                  className="form-control"
                                  placeholder="e.g., 50000"
                                />
                              </div>
                              <div className="form-group col-md-12">
                                <label>Reason for Leaving</label>
                                <textarea
                                  onChange={(e) =>
                                    handleArrayInput(e, "workExperience", index)
                                  }
                                  value={exp.reasonForLeaving}
                                  name="reasonForLeaving"
                                  className="form-control"
                                  rows="2"
                                  placeholder="Brief reason for leaving the organization"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* Add References Section at the end */}
                    <div className="col-md-12">
                      <h4 className="text-primary">References</h4>
                      <hr />
                    </div>

                    {formData.references.map((reference, index) => (
                      <div className="col-md-12 mb-3" key={`ref-${index}`}>
                        <div className="card">
                          <div className="card-body">
                            <h6>Reference {index + 1}</h6>
                            <div className="row">
                              <div className="form-group col-md-3">
                                <label>Name</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "references", index)
                                  }
                                  value={reference.name}
                                  type="text"
                                  name="name"
                                  className="form-control"
                                />
                              </div>
                              <div className="form-group col-md-3">
                                <label>Position</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "references", index)
                                  }
                                  value={reference.position}
                                  type="text"
                                  name="position"
                                  className="form-control"
                                />
                              </div>
                              <div className="form-group col-md-3">
                                <label>Organization</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "references", index)
                                  }
                                  value={reference.organization}
                                  type="text"
                                  name="organization"
                                  className="form-control"
                                />
                              </div>
                              <div className="form-group col-md-3">
                                <label>Mobile Number</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "references", index)
                                  }
                                  value={reference.mobile}
                                  type="text"
                                  name="mobile"
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                {/* Acquaintance Section */}
                    <div className="col-md-12">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4 className="text-primary">
                          Acquaintance

                        </h4>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            addArrayItem("acquaintance", {
                              name: "",
                              relationship: "",
                              department: "",
                              organization: ""
                              
                            })
                          }>
                          Add Acquaintance
                        </button>
                      </div>
                      <hr />
                    </div>

                    {formData.acquaintance.map((acquaintance, index) => (
                      <div className="col-md-12 mb-3" key={`train-${index}`}>
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6>Acquaintance {index + 1}</h6>
                              {index > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() =>
                                    removeArrayItem("acquaintance", index)
                                  }>
                                  Remove
                                </button>
                              )}
                            </div>
                            <div className="row">
                              
                              <div className="form-group col-md-4">
                                <label>Name</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "acquaintance", index)
                                  }
                                  value={acquaintance.name}
                                  type="text"
                                  name="name"
                                  className="form-control"
                                  placeholder="Enter Employeer's Name"
                                />
                              </div>
                              
                              <div className="form-group col-md-8">
                                <label>Relationship</label>
                                <input
                                  onChange={(e) =>
                                    handleArrayInput(e, "acquaintance", index)
                                  }
                                  value={acquaintance.relationship}
                                  type="text"
                                  name="relationship"
                                  className="form-control"
                                  placeholder="e.g., Father,Mother"
                                />
                              </div>
                              <div className="form-group col-md-6">
                                <label>Department</label>
                                <input
                                  onChange={(e) => {
                                    handleArrayInput(
                                      e,
                                      "acquaintance",
                                      index
                                    );
                                   
                                  }}
                                  value={acquaintance.department}
                                  type="text"
                                  name="department"
                                  className="form-control"
                                  placeholder="e.g. Software,HR"
                                />
                              </div>
                              <div className="form-group col-md-6">
                                <label>Organization</label>
                                <input
                                  onChange={(e) => {
                                    handleArrayInput(
                                      e,
                                      "acquaintance",
                                      index
                                    );
                                    
                                  }}
                                  value={acquaintance.organization}
                                  type="text"
                                  name="organization"
                                  className="form-control"
                                  placeholder="e.g. Neophyte Ambient Intelligence"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
                
              

                {/* Submit Button */}
                <div className="form-group col-md-12 text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    style={{ minWidth: "200px" }}>
                    Create User
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AddUser;
